// Smooth scrolling only on the home page (for the in-page "Explore" link).
require("./src/sass/site.sass");

const { trackEvent } = require("./src/_tools/analytics");

exports.onPreRouteUpdate = ({ location }) => {
  const element = document.querySelector("html");
  if (element) {
    element.style.scrollBehavior = location.pathname !== "/" ? "auto" : "smooth";
  }
};

// Start each new page at the top unless the URL targets an anchor.
exports.onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }

  trackEvent("page_view", {
    path: location.pathname,
    page_path: `${location.pathname}${location.search}`,
    page_location: location.href,
    page_title: document.title,
  });
};
